export function initMobileNavigation() {
    const toggle = document.getElementById('mobile-menu-toggle');
    const closeButton = document.getElementById('mobile-menu-close');
    const backdrop = document.getElementById('mobile-menu-backdrop');
    const panel = document.getElementById('mobile-menu-panel');
    const submenuToggles = [...document.querySelectorAll('[data-mobile-submenu-toggle]')];

    if (!toggle || !closeButton || !backdrop || !panel || submenuToggles.length === 0) {
        return;
    }

    const focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
    let isOpen = false;
    let lastFocusedElement = null;

    const setSubmenuState = (submenuToggle, open) => {
        const submenu = submenuToggle.closest('.mobile-nav__item--submenu')?.querySelector('[data-mobile-submenu]');
        if (!submenu) {
            return;
        }

        submenuToggle.setAttribute('aria-expanded', String(open));
        submenu.hidden = !open;
    };

    const setMenuState = (open, restoreFocus = true) => {
        isOpen = open;
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? 'Zamknij menu' : 'Otwórz menu');
        panel.setAttribute('aria-hidden', String(!open));
        panel.classList.toggle('is-open', open);
        backdrop.classList.toggle('is-open', open);
        backdrop.disabled = !open;
        document.body.classList.toggle('mobile-menu-open', open);

        if (open) {
            lastFocusedElement = document.activeElement;
            panel.removeAttribute('inert');
            panel.scrollTop = 0;
            window.setTimeout(() => {
                if (isOpen) {
                    closeButton.focus({ preventScroll: true });
                }
            }, 260);
            return;
        }

        panel.setAttribute('inert', '');
        submenuToggles.forEach((submenuToggle) => setSubmenuState(submenuToggle, false));
        if (restoreFocus && lastFocusedElement instanceof HTMLElement) {
            lastFocusedElement.focus();
        }
    };

    toggle.addEventListener('click', () => setMenuState(!isOpen));
    closeButton.addEventListener('click', () => setMenuState(false));
    backdrop.addEventListener('click', () => setMenuState(false));
    submenuToggles.forEach((submenuToggle) => submenuToggle.addEventListener('click', () => {
        setSubmenuState(submenuToggle, submenuToggle.getAttribute('aria-expanded') !== 'true');
    }));

    panel.addEventListener('click', (event) => {
        if (event.target.closest('a[href]')) {
            setMenuState(false);
        }
    });

    document.addEventListener('keydown', (event) => {
        if (!isOpen) {
            return;
        }

        if (event.key === 'Escape') {
            event.preventDefault();
            setMenuState(false);
            return;
        }

        if (event.key !== 'Tab') {
            return;
        }

        const focusableElements = [...panel.querySelectorAll(focusableSelector)]
            .filter((element) => !element.closest('[hidden]'));
        const firstElement = focusableElements[0];
        const lastElement = focusableElements.at(-1);

        if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement?.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement?.focus();
        }
    });

    window.matchMedia('(min-width: 768px)').addEventListener('change', (event) => {
        if (event.matches && isOpen) {
            setMenuState(false, false);
        }
    });
}
